module.exports = __webpack_public_path__ + "static/fonts/DMSans-Regular.1f26d41d.woff2";